import { AdsEnrichedVideoContext, AdsEnrichedVideoContextOverrider } from "@mp-commons/modules/ads/AdsEnrichedVideoContext.js";

let hasBeenManuallyStartedOnce: boolean = false;

export class MegarideAdsEnrichedVideoContext extends AdsEnrichedVideoContextOverrider {
    
    public readonly isAdsEnriched: boolean;

    constructor(ctl: AdsEnrichedVideoContext) {
        super(ctl);
        this.isAdsEnriched = ctl.isAdsEnriched;
    }


    public togglePlay(manualPlay: boolean): Promise<boolean> {
        return this.originalContext.togglePlay(manualPlay).then(x => {
            if(!this.originalContext.isPaused &&
                manualPlay && 
                !hasBeenManuallyStartedOnce) {
                    hasBeenManuallyStartedOnce= true;
                    this.originalContext.unmute();
            }
            return x;   
        })
    }

}